import { createContext } from 'react';

import type { ClickStreamMetadata } from '../../../constants/TouringClickStreamEvents';

type TourCalendarContextType = {
  clickStreamMetadata?: ClickStreamMetadata;
  lastActivatedAt?: number;
  listingAlias?: string;
  listingAddress?: string;
  propertyPhotoUrl?: string;
  refetchTouringData?: () => void;
};

const TourCalendarContext = createContext<TourCalendarContextType>({
  clickStreamMetadata: undefined,
  lastActivatedAt: 0,
  listingAlias: '',
  listingAddress: '',
  propertyPhotoUrl: '',
  refetchTouringData: () => {},
});

export default TourCalendarContext;
